<template lang="pug">
  el-dialog(
    id="ConfirmDialog-dialogWrapper",
    :title="$t('')",
    :visible.sync="confirmDialogVisible",
    width="30%",
    @close='dialogClosed',
    append-to-body,
    v-shortkey="{confirm: ['enter']}",
    @shortkey.native="keyboardShortcut",
    :close-on-click-modal='false',
    :close-on-press-escape='false',
  )
    div(id="ConfirmDialog-question") {{ question }}
    hr.header
    el-button.float-right(v-if='percentDone === 0', id="ConfirmDialog-closeDialogButton" @click='dialogClosed', type='info', size='mini', :disabled='processing')
      span {{ $t('NO') }} &nbsp; &nbsp;
      font-awesome-icon(icon="ban")
    span.float-right &nbsp;
    el-button.float-right(v-if='percentDone === 0', id="ConfirmDialog-confirmDialogButton" ref='confirmButton', @click='confirmed', type='success', size='mini', :disabled='processing')
      span {{ $t('YES') }} &nbsp; &nbsp;
      font-awesome-icon(icon="thumbs-up")
    br
    el-progress(v-if='percentDone > 0', :text-inside='true', :stroke-width='15', :percentage='percentDone', status='success')
</template>
<script>

export default {
  props: {
    'question': {
      type: String,
      default: 'Are you sure?'
    },
    confirmDialogVisible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    },
    percentDone: {
      type: Number,
      default: 0
    }
  },
  mixins: [
  ],
  data () {
    return {
      processing: false
    }
  },
  methods: {
    keyboardShortcut ($event) {
      switch ($event.srcKey) {
        case 'confirm':
          this.confirmed()
          break
      }
    },
    confirmed () {
      this.processing = true
      this.$emit('confirmed', this.data)
    },
    dialogClosed () {
      this.percentDone = 0
      this.processing = false
      this.$emit('closed', this.data)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";

</style>



// WEBPACK FOOTER //
// src/components/Common/ConfirmDialog.vue